// extracted by mini-css-extract-plugin
module.exports =  {"forgotPassword":"nGwHe0HJA2gd6nDTjE2A","input":"oUBJgvEdl7j89_PwMJpa"};